import { Component, HostListener, OnInit } from '@angular/core';
import {
  FoldersRepository,
  IFolder,
} from '../../../../state/folders.repository';
import { FoldersService } from '../../../../state/folders.service';
import { TrackRender } from 'app/shared/front-perfomance';

@TrackRender()
@Component({
  selector: 'app-folderpage',
  templateUrl: './folderpage.component.html',
  styleUrls: ['./folderpage.component.scss'],
})
export class FolderpageComponent implements OnInit {
  innerWidth = 0;
  deleteConfirmation: IFolder | null = null;

  constructor(public repo: FoldersRepository, public service: FoldersService) {}
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
  }
  ngOnInit(): void {
    this.service.reloadPage().subscribe();
    this.innerWidth = window.innerWidth;
  }
  refreshDataProject() {
    this.service.reloadPage().subscribe();
  }
  handleDeleteClick(post: IFolder) {
    this.service.deleteCustom(post.id).subscribe((x) => {
      this.refreshDataProject();
    });
  }
}
